"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Vertical: {
    '& > *': {
      flexGrow: 1,
      flexShrink: 1
    },
    display: 'flex',
    flexDirection: 'row'
  },
  Horizontal: {
    '& > *': {
      flexGrow: 1,
      flexShrink: 1
    },
    display: 'flex',
    flexDirection: 'column'
  }
};
exports["default"] = _default;
//# sourceMappingURL=style.js.map